module.exports = __webpack_public_path__ + "img/poker-d02.9df992fd.svg";